import { Box } from "@mui/material";
import React from "react";
import BasicLogo from "./logo";
import styles from "./style.module.css";
import ProjectForm from "./project-form";
import { useTheme } from "../../../context/themeContext";
import useProtectedAuth from "../../../hooks/useProtectedAuth";

const EditProject = () => {
  useProtectedAuth();
  const { theme } = useTheme();

  return (
    <Box
      className={styles.boardSubmission}
      style={{ paddingBottom: "5rem" }}
      sx={{ bgcolor: theme.palette.lightgrey.lightgrey500 }}
    >
      <Box
        sx={{
          width: {
            xs: "100%",
          },
        }}
      >
        <BasicLogo />
        <ProjectForm />
      </Box>
    </Box>
  );
};

export default EditProject;
